import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'loyaltic-reports-login',
  templateUrl: './reports-login.component.html',
  styleUrls: ['./reports-login.component.scss']
})
export class ReportsLoginComponent implements OnInit {

  constructor(private readonly router: Router) { }

  ngOnInit() {
  }

  password = '';

  onLogin() {
    if (this.password === 'gbsomAnalytics2026!') {
      localStorage.setItem('reportsAuthenticated', 'true');
      this.router.navigateByUrl('/reports');
    } else {
      alert('Invalid credentials');
    }
  }

}
